const eventTypes = {
  consumer: 0,
  acuratraining: 1,
  hondatraining: 2,
  zdxdrive: 3,
  prologuedrive: 4,
};

export default eventTypes;
